import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Map } from "immutable";
import { get } from "lodash";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import * as actions from "MODULES/Lots/actions";
import { BUYER, CO_BUYER, THIRD_BUYER, USER } from "MODULES/users/constants";
import { CREATED_AT, ID, SHIPPING_TYPE } from "APP_ROOT/constants";
import { DOM_LIFE_YEARS, LLP, PART } from "MODULES/parts/constants";
import { LOT } from "MODULES/Lots/constants";
import Form from "../Form";

function EditPart({
  open,
  close,
  selectedLineItem,
  onSubmit,
  lot,
  currentUser
}) {
  const initialValues = {
    ...selectedLineItem,
    displayCoBuyer1: !!(selectedLineItem && selectedLineItem.co_buyer_id),
    displayCoBuyer2: !!(selectedLineItem && selectedLineItem.third_buyer_id),
    created_at: lot.get(CREATED_AT),
    insurance_type: selectedLineItem && selectedLineItem.insurance_type,
    displayCoBuyerFields: !!(selectedLineItem && selectedLineItem.co_buyer_id),
    displayThirdBuyerFields: !!(
      selectedLineItem && selectedLineItem.third_buyer_id
    ),
    read_only_buyer: lot.getIn([BUYER, "full_name"]),
    reserve_for_seller_id:
      (selectedLineItem && selectedLineItem.reserve_for_seller_id) ||
      currentUser.get(ID),
    tagged_by: selectedLineItem && selectedLineItem.tagged_by,
    tagged_by_id: selectedLineItem && selectedLineItem.tagged_by_id,
    tagged_by_hold: selectedLineItem && selectedLineItem.tagged_by_hold
  };

  const lineItem = {
    co_buyer: lot.get(CO_BUYER) && lot.get(CO_BUYER).toJS(),
    third_buyer: lot.get(THIRD_BUYER) && lot.get(THIRD_BUYER).toJS()
  };

  const [selectedPart, setSelectedPart] = useState(
    get(selectedLineItem, PART, {})
  );

  const domLifeYears = get(
    selectedPart,
    DOM_LIFE_YEARS,
    get(initialValues, "part.dom_life_years")
  );
  const llp = get(selectedPart, LLP, get(initialValues, "part.llp"));

  return (
    <Modal open={open} close={close} dialogClass="modal-lg">
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Edit Part</h4>
      </Header>
      <Form
        onSubmit={onSubmit}
        close={close}
        shippingType={lot.get(SHIPPING_TYPE)}
        initialValues={initialValues}
        selectedPart={selectedPart}
        setSelectedPart={setSelectedPart}
        domLifeYears={domLifeYears}
        llp={llp}
        lineItem={lineItem}
        enableReinitialize
        selectedLineItem={selectedLineItem}
      />
    </Modal>
  );
}

export default connect(
  state => ({
    lot: state.lotDetail.get(LOT),
    currentUser: state.session.get(USER)
  }),
  (dispatch, ownProps) => ({
    onSubmit: data =>
      dispatch(actions.updateLineItem(ownProps.selectedLineItem.id, data))
  })
)(EditPart);

EditPart.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  selectedLineItem: PropTypes.instanceOf(Object),
  onSubmit: PropTypes.func.isRequired,
  lot: PropTypes.instanceOf(Map),
  currentUser: PropTypes.instanceOf(Map)
};



// WEBPACK FOOTER //
// ./app/modules/Lots/Detail/LineItemsTable/EditPart/EditPart.jsx